import { Routes } from '@/app/routes'

export function getDefaultPostLoginRedirectUrl(): string {
  return Routes.Home.root
}

// Validates a user-supplied return path before redirecting to it.
// Rejects external URLs (anything that doesn't start with a single "/"),
// protocol-relative URLs ("//host/..."), backslash tricks, and the login
// page itself (which would create a redirect loop). Also rejects embedded
// tab/LF/CR characters, which the WHATWG URL parser silently strips during
// parsing — leaving them in would let "/\t//evil.com" slip past the
// protocol-relative guard and resolve to https://evil.com after parsing.
export function isSafeReturnPath(path: string): boolean {
  if (path === '') return false
  if (/[\t\n\r]/.test(path)) return false
  if (!path.startsWith('/')) return false
  if (path.startsWith('//') || path.startsWith('/\\')) return false
  if (
    path === Routes.Login.root ||
    path.startsWith(`${Routes.Login.root}?`) ||
    path.startsWith(`${Routes.Login.root}/`)
  ) {
    return false
  }
  return true
}

export function resolvePostLoginRedirect(
  returnPath: string | null | undefined,
): string {
  if (typeof returnPath !== 'string') return getDefaultPostLoginRedirectUrl()
  if (isSafeReturnPath(returnPath)) return returnPath
  return getDefaultPostLoginRedirectUrl()
}
